import { render, staticRenderFns } from "./TicketCard.vue?vue&type=template&id=9c58f02c&scoped=true&"
import script from "./TicketCard.vue?vue&type=script&lang=js&"
export * from "./TicketCard.vue?vue&type=script&lang=js&"
import style0 from "./TicketCard.vue?vue&type=style&index=0&id=9c58f02c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c58f02c",
  null
  
)

export default component.exports